import React from 'react';
import { Svg, Path } from 'react-native-svg';

export const HelpIcon = ({ color = '#000', size = '14px' }) => {
    return (
        <Svg
            height={size}
            width={size}
            className="helpIcon"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <Path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M10 18C14.4179 18 18 14.4179 18 10C18 5.58211 14.4179 2 10 2C5.58211 2 2 5.58211 2 10C2 14.4179 5.58211 18 10 18ZM10 20C15.5225 20 20 15.5225 20 10C20 4.47754 15.5225 0 10 0C4.47754 0 0 4.47754 0 10C0 15.5225 4.47754 20 10 20Z"
                fill={color}
            />
            <Path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M10 6C8.89543 6 8 6.89543 8 8C8 8.55229 7.55228 9 7 9C6.44772 9 6 8.55229 6 8C6 5.79086 7.79086 4 10 4H10.2759C12.3327 4 14 5.66734 14 7.7241C14 8.82934 13.5091 9.87748 12.66 10.585L11.7196 11.3687C11.2636 11.7487 11 11.9064 11 12.5C11 13.0523 10.5523 13.5 10 13.5C9.44771 13.5 9 13.0523 9 12.5C9 11.3129 9.52729 10.5922 10.4393 9.83224L11.3796 9.04859C11.7727 8.72102 12 8.23578 12 7.7241C12 6.77191 11.2281 6 10.2759 6H10Z"
                fill={color}
            />
            <Path
                d="M9 16C9 15.4477 9.44771 15 10 15C10.5523 15 11 15.4477 11 16C11 16.5523 10.5523 17 10 17C9.44771 17 9 16.5523 9 16Z"
                fill={color}
            />
        </Svg>
    );
};

export default HelpIcon;
